// extracted by mini-css-extract-plugin
export var faqList = "faq-list-module--faq-list--TQs0p";